// "$1,923" — whole dollars with thousands separators, per the shop design.
// One formatter for every card: the same product must not read $1,923 in the
// feature and $1923 two sections later in the grid.
export const formatPrice = price => {
  const value = Number(price);
  if (!Number.isFinite(value) || value <= 0) return null;
  return `$${Math.round(value).toLocaleString('en-US')}`;
};
